import { validateEmail } from '@/functions/utility.js';
import { mapActions } from 'vuex';

// Generic functionality for "add emails to list"
// Expected properties:

// sendEmails(): function that sends the emails to the BE, passed an array of valid emails
export default {
  data: function () {
    return {
      emailInput: '',
      validEmails: []
    };
  },
  methods: {
    ...mapActions([
      'popups/settings/errorAddEmailInvalid',
      'popups/settings/errorAddEmailAlreadyAdded',
      'popups/settings/errorAddEmailInvalidAndAlreadyAdded'
    ]),
    onEmailInput(event) {
      if (
        (event.data == null && (event.inputType == 'insertText' || event.inputType == 'insertLineBreak')) ||
        event.data == '\n' ||
        event.data == ' ' ||
        event.data === ','
      ) {
        this.addEmailToList(this.emailInput)
      }
    },
    async addAllEmails() {
      //add any emails in the input box
      if (this.emailInput) this.addEmailToList(this.emailInput)
      //get values from popup to create new user
      if (this.validEmails.length) await this.sendEmails(this.validEmails)

      this.resetForm()
      this['modal/close']()
    },
    resetForm() {
      this.validEmails = []
    },
    removeEmailFromList(e) {
      let id = e.target.id
      this.validEmails = this.validEmails.filter((email) => email !== id)
    },
    resetEmailInput() {
      this.emailInput = ''
    },
    addEmailToList(value) {
      // this.width = this.$refs.emailItem.clientWidth;

      // Split by comma or space
      let emails = value.split(/[,\s]/)
      let finalEmails = []

      // Push unique emails, trimmed + lowercase
      for (let email of emails) {
        if (finalEmails.includes(email) || email == '') continue
        finalEmails.push(email.trim().toLowerCase())
      }

      let setAlreadyAdded = []
      let setNotValid = []

      for (let email of finalEmails) {
        // Validate email against regex
        if (!validateEmail(email)) {
          setNotValid.push(email)
          continue
        }

        // Make sure it's not already present
        if (this.validEmails.includes(email)) {
          setAlreadyAdded.push(email)
          continue
        }

        this.validEmails.push(email)
      }

      if (setAlreadyAdded.length && setNotValid.length)
        this['popups/settings/errorAddEmailInvalidAndAlreadyAdded']([...setAlreadyAdded, ...setNotValid])
      else if (setAlreadyAdded.length) this['popups/settings/errorAddEmailAlreadyAdded'](setAlreadyAdded)
      else if (setNotValid.length) this['popups/settings/errorAddEmailInvalid'](setNotValid)
      this.resetEmailInput()
    }
  }
};
